import React from 'react';
import PropTypes from 'prop-types';
import InputBlocks from './InputBlocks';
import './SDKConfigurations.scss';
import useForm from '../../../hooks/useForm';

export default function SDKConfigurations({ value, meta, onChange }) {
  const [, getInputProps] = useForm(value, {
    meta,
    onChange,
  });

  return (
    <div className="sdk-configurations">
      {InputBlocks.blocks.map(block => (
        <div className="sdk-configurations-block">
          <div className="sdk-configurations-title">{block.title}</div>
          {block.inputs.map((input, i) => {
            const Input = input.component;
            const inputProps = getInputProps(input, i);
            if (inputProps.invisible) return null;
            return (
              <Input
                {...inputProps}
                className={`${input.className || 'sdk-configurations-input'}`}
              />
            );
          })}
        </div>
      ))}
    </div>
  );
}

SDKConfigurations.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.object,
  meta: PropTypes.object,
};

SDKConfigurations.defaultProps = {
  value: {},
  meta: {},
  onChange: () => {},
};
